import { z } from "zod";
import { SystemEntity } from "@erp/shared-types";
import { defineStepConfig } from "../../registry/helpers";
import { entityOfType } from "../../utils/system-entities";

export const csvTransformColumnSchema = z.object({
  name: z.string().min(1),
  type: z.enum(["string", "number", "date", "boolean"]),
  description: z.string().optional(),
});

export const csvTransformStep = defineStepConfig({
  type: "csv_transform",
  name: "CSV/XLSX Transform",
  description:
    "Generic one-shot CSV/XLSX transform: takes a tabular document and produces a CSV matching the configured output schema using AI.",
  category: "AI & Agents",

  inputSchema: z.object({
    inputDocument: entityOfType(SystemEntity.CORE_DOCUMENT).describe(
      "Document containing the input CSV",
    ),
  }),

  outputSchema: z.object({
    outputDocument: entityOfType(SystemEntity.CORE_DOCUMENT).describe(
      "Document containing the transformed CSV",
    ),
  }),

  configSchema: z.object({
    columns: z.array(csvTransformColumnSchema).min(1),
    instructions: z.string().optional(),
  }),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "15 minutes",
  },
});
